module.exports = __webpack_public_path__ + "static/media/cammino_1.8ab2b6c3.jpg";